import asyncActionTypes from '../actions/types.js';

const initialState = {
  error: null,
  loading: false,
};

const AmaiaChat = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.SEARCH_AMAIA.START:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case asyncActionTypes.SEARCH_AMAIA.SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case asyncActionTypes.SEARCH_AMAIA.FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default AmaiaChat;